import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useClubContext } from './useClubContext';

/**
 * Hook to manage club cache based on current route
 * Clears cache when navigating away from club pages
 */
export const useClubCacheManager = () => {
  const location = useLocation();
  const { clearCacheOnNavigation, currentClubHandle } = useClubContext();

  useEffect(() => {
    const currentPath = location.pathname;
    const isClubPage = currentPath.includes('/venues/');

    // If we're not on a club page and we have a current club, clear the cache
    if (!isClubPage && currentClubHandle) {
      clearCacheOnNavigation();
    }
  }, [location.pathname, currentClubHandle, clearCacheOnNavigation]);
};
